




























































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import BlockView from '../components/blockView.vue';
import UploadImg from '../components/uploadImg.vue';
import skuSidebar from '../../components/skuSidebar.vue';
import { v4 as uuidv4 } from 'uuid';
import { categoryThreeId } from '@/utils/api';

interface batchSetUp {
  suggestCostPrice: number | undefined; //供货价
  suggestMarketPrice: number | undefined; //市场销售价
  stockCount: number | undefined; //库存总量
  skuCode: string; //商家SKU编号
  published: string | number;
}

@Component({
  components: {
    BlockView,
    UploadImg,
    skuSidebar,
  },
})
export default class PriceStock extends Vue {
  @Prop(Object) goodsInfo!: object;
  @Watch('goodsInfo', { immediate: true, deep: true })
  onPersonChanged(newVal: object, oldVal: object) {
    // console.log('#################',newVal);
    // this.tableData=newVal['commoditySkuInfo'];
    this.specificationItems = newVal['specificationItems'];
  }
  specificationItems: Array<object> = []; // 规格数据
  skuData = false; //抽屉是否显示
  skuList: object = {}; //传递给抽屉数据
  isBatch = true; //批量设置显示隐藏
  // 批量设置
  batchSetUp: batchSetUp = {
    suggestCostPrice: undefined, //供货价
    suggestMarketPrice: undefined, //市场销售价
    stockCount: undefined, //库存总量
    skuCode: '', //商家SKU编号
    published: 3,
  };
  tableData: Array<object> = []; //表格数据
  temporaryData: Array<object> = []; //暂存老数据
  specsCols: Array<object> = []; //table表格动态列
  isFold = true; //折叠展示
  restoreData: Array<string> = [
    'uuid',
    'suggestCostPrice',
    'suggestMarketPrice',
    'skuStock',
    'saleUnit',
    'skuCode',
    'spuSkuImages',
    'barCode',
    'productModel',
    'orderNo',
    'weight',
    'length',
    'width',
    'hight',
    'skuId',
    'taxRate',
    'published',
    'id',
    'spuId',
    'deleted',
    'modifiedDate',
    'modifiedBy',
    'createdDate',
    'createdBy',
  ]; //需要还原的字段名称
  $refs: any;
  allAlign = null;

  created() {
    console.log('price stock ');
    const that = this;
    const goodsInfo = this.goodsInfo;
    if (goodsInfo['commoditySkuInfo'] && goodsInfo['specificationItems']) {
      if (goodsInfo['specificationItems'].length > 0) {
        that.specificationItems = goodsInfo['specificationItems'];
        that.columnName();
      }
      that.temporaryData = goodsInfo['commoditySkuInfo'];
      that.tableData = goodsInfo['commoditySkuInfo'];
    }
  }
  /* 基础信息展示折叠 */
  foldUp() {
    this.isFold = !this.isFold;
  }
  /* 删除SKU */
  deleteSku(index) {
    this.specificationItems.splice(index, 1);
    this.convertToSkuList(); //重新计算
  }
  /* 删除规格值 */
  specsDelete(index, val) {
    const specificationValues = this.specificationItems[index]['specificationValues'];
    const sub = specificationValues.findIndex((item) => item['specsValId'] == val);
    specificationValues.splice(sub, 1);
    this.convertToSkuList(); //重新计算
  }
  /* 追加规格值 */
  addSpecsVal(index) {
    (this.specificationItems[index]['specificationValues'] as Array<object>).push({
      specsValId: uuidv4(),
      specItemValue: '',
      specItemImageUrl: '',
    });
  }
  /* 新增规格 */
  addSpecs() {
    const spuName = this.goodsInfo['spuName'];
    if (spuName == '') {
      this.$message({
        message: '请输入商品标题',
        type: 'warning',
      });
    } else {
      const data = {
        specItemName: '',
        checked: false, //显示隐藏上传规格图片
        specificationValues: [
          {
            specsValId: uuidv4(),
            specItemValue: '',
            specItemImageUrl: '',
          },
        ],
      };
      (this.specificationItems as Array<object>).push(data);
    }
  }
  /* 实时更新 */
  convertToSkuList() {
    this.screenVal();
    this.columnName();
    const specificationItems = this.specificationItems;
    const skuSpecifications: Array<any> = [];
    specificationItems.forEach((item: object, index: number) => {
      if (item['specItemName'] != '') {
        const single = [];
        const specificationValues = item['specificationValues'];
        specificationValues.forEach((el: object, i: number) => {
          if (el['specItemValue'] != '') {
            const data = {
              specItemName: item['specItemName'],
              specItemValue: el['specItemValue'],
              specItemImageUrl: el['specItemImageUrl'],
            };
            single.push(data);
          }
        });
        if (single.length > 0) {
          skuSpecifications.push(single);
        }
      }
    });
    // if(skuSpecifications.length>0 && skuSpecifications[0].length>0){
    const allSku = this.calcSku(skuSpecifications) as any;
    const commoditySkuInfo = [];
    for (const item of allSku) {
      let skuName = this.goodsInfo['spuName'] + ' ';
      let skuNameTitle = '';
      for (const el of item) {
        skuName += el['specItemValue'] + ' ';
        skuNameTitle += el['specItemValue'] + ',';
      }
      const data = {
        skuName,
        skuNameTitle,
        skuSpecifications: item,
        spuId: '',
        deleted: false,
        modifiedDate: '',
        modifiedBy: {},
        createdDate: '',
        createdBy: {},
        id: '',
        skuCode: '',
        suggestCostPrice: undefined, //成本价格
        suggestMarketPrice: undefined, //市场销售价
        hight: 0, //高 mm
        length: 0, //长 mm
        published: 1, //发布标识 0:未发布，1:发布
        saleUnit: '', //单位
        skuId: '', //sku_id
        taxRate: 0, //税率
        weight: 0, //重量kg
        width: 0, //宽 mm
        skuStock: {
          //商品SKU库存
          curStock: 0, //可用库存
          preStock: 0, //预占库存
          stockCount: undefined, //库存总量
          version: 0, //版本
        },
        isEnable: true,
        spuSkuImages: [], //SKU图片存储
        barCode: '', //产品条码
        productModel: '', //产品型号
        orderNo: '', //订单编号
      };
      commoditySkuInfo.push(data);
    }
    if (commoditySkuInfo.length > 200) {
      this.$message({
        message: '最多支持生成200个sku！',
        type: 'error',
      });
    } else {
      this.temporaryData = commoditySkuInfo;
    }
    // }
  }
  /* 计算笛卡尔积 */
  calcSku(list) {
    return Array.prototype.reduce.call(
      list,
      function (total: any, current) {
        const ret: any[] = [];
        total.forEach(function (a) {
          current.forEach(function (b) {
            ret.push(a.concat([b]));
          });
        });
        return ret;
      },
      [[]]
    );
  }
  // /* 深拷贝一下 */
  get tableDataChange() {
    return JSON.parse(JSON.stringify(this.temporaryData));
  }
  @Watch('tableDataChange', { immediate: true, deep: true })
  onchange(newVal: Array<object>, oldVal: Array<object>) {
    const restoreData = this.restoreData;
    if (oldVal) {
      if (newVal.length > oldVal.length) {
        newVal.forEach((item) => {
          oldVal.forEach((el) => {
            if (item['skuNameTitle'] == el['skuNameTitle']) {
              // console.log('item skuNameTitle :', item['skuNameTitle'], 'el skuNameTitle', el['skuNameTitle']);
              restoreData.forEach((name) => {
                item[name] = el[name];
              });
            }
          });
        });
      } else if (newVal.length == oldVal.length) {
        if (newVal[0]['skuNameTitle'].length > oldVal[0]['skuNameTitle'].length) {
          newVal.forEach((item) => {
            oldVal.forEach((el) => {
              if (item['skuNameTitle'] == el['skuNameTitle']) {
                restoreData.forEach((name) => {
                  item[name] = el[name];
                });
              }
            });
          });
        } else {
          oldVal.forEach((el) => {
            newVal.forEach((item) => {
              if (el['skuNameTitle'] == item['skuNameTitle']) {
                restoreData.forEach((name) => {
                  item[name] = el[name];
                });
              }
            });
          });
        }
      } else {
        oldVal.forEach((el) => {
          newVal.forEach((item) => {
            if (el['skuNameTitle'].includes(item['skuNameTitle'])) {
              restoreData.forEach((name) => {
                item[name] = el[name];
              });
            }
          });
        });
      }
      this.tableData = newVal;
      this.$emit('commoditySkuInfoTo', newVal);
    } else {
      if (newVal.length > 0) {
        this.tableData = newVal;
        this.$emit('commoditySkuInfoTo', newVal);
      }
    }
  }
  /* 筛选重复规格名称和值 */
  screenVal() {
    const specificationItems = this.specificationItems;
    const specsNames = [];
    specificationItems.forEach((item, index) => {
      const specItemName = item['specItemName'];
      if (specItemName != '') {
        if (specsNames.indexOf(specItemName) == -1) {
          specsNames.push(specItemName);
        } else {
          this.$message.error('规格名称重复，请重新填写');
          this.specificationItems[index]['specItemName'] = '';
        }
        const specsValues = [];
        const specificationValues = item['specificationValues'];
        specificationValues.forEach((el, i) => {
          const specItemValue = el['specItemValue'];
          if (specItemValue != '') {
            if (specsValues.indexOf(specItemValue) == -1) {
              specsValues.push(specItemValue);
            } else {
              this.$message.error('规格值重复，请重新填写');
              this.specificationItems[index]['specificationValues'][i]['specItemValue'] = '';
            }
          }
        });
      }
    });
  }
  /* 批量确认 */
  batchConfirm() {
    const specsCols = this.specsCols;
    let tableData = JSON.parse(JSON.stringify(this.tableData));
    let num = 0;
    specsCols.forEach((item, index) => {
      if (item['choiceName'] != '') {
        const temporary = [];
        tableData.forEach((el, i) => {
          if (item['choiceName'] == el['skuSpecifications'][index].specItemValue) {
            temporary.push(el);
          }
        });
        tableData = temporary;
      } else {
        num++;
      }
    });
    const subscript = [];
    if (num == specsCols.length) {
      this.tableData.forEach((item, index) => {
        subscript.push(index);
      });
    } else {
      tableData.forEach((e) => {
        const index = this.tableData.findIndex((item) => item['skuNameTitle'] == e['skuNameTitle']);
        subscript.push(index);
      });
    }
    const suggestCostPrice = this.batchSetUp['suggestCostPrice'];
    const suggestMarketPrice = this.batchSetUp['suggestMarketPrice'];
    const stockCount = this.batchSetUp['stockCount'];
    const skuCode = this.batchSetUp['skuCode'];
    const published = this.batchSetUp['published'];
    subscript.forEach((item) => {
      if (suggestCostPrice) this.tableData[item]['suggestCostPrice'] = suggestCostPrice;
      if (suggestMarketPrice) this.tableData[item]['suggestMarketPrice'] = suggestMarketPrice;
      if (stockCount || stockCount == 0) this.tableData[item]['skuStock']['stockCount'] = stockCount;
      if (skuCode != '') this.tableData[item]['skuCode'] = skuCode;
      if (published != 3) this.tableData[item]['published'] = published;
    });
    this.temporaryData = this.tableData;
    this.tableData = this.tableData;
  }
  /* 合并单元格 */
  objectSpanMethod({ row, _rowIndex, _columnIndex, column, visibleData }) {
    const spanArr = []; //合并数据
    let pos = 0; //数据下标
    const tableData = this.tableData;
    for (let i = 0; i < tableData.length; i++) {
      const el = tableData[i];
      if (i == 0) {
        spanArr.push(1);
        pos = 0;
      } else {
        if (tableData[i]?.['skuSpecifications'] && tableData[i]?.['skuSpecifications'].length) {
          if (tableData[i]['skuSpecifications'][0]['specItemValue'] === tableData[i - 1]['skuSpecifications'][0]['specItemValue']) {
            spanArr[pos] += 1;
            spanArr.push(0);
          } else {
            spanArr.push(1);
            pos = i;
          }
        }
      }
    }
    if (_columnIndex == 0) {
      const rows = spanArr[_rowIndex];
      const cols = rows > 0 ? 1 : 0;
      return {
        rowspan: rows,
        colspan: cols,
      };
    }
  }
  /* 动态table列展示 */
  columnName() {
    const specificationItems = this.specificationItems;
    const specsCols = [];
    specificationItems.forEach((item, index) => {
      if (item['specItemName'] != '') {
        const specificationValues = [];
        item['specificationValues'].forEach((el) => {
          if (el['specItemValue'] != '') {
            specificationValues.push(el);
          }
          if (el['specItemImageUrl'] && el['specItemImageUrl'] != '' && index == 0) {
            item['checked'] = true;
          }
        });
        if (specificationValues.length > 0) {
          specsCols.push({ specItemName: item['specItemName'], choiceName: '', specificationValues });
        }
      }
    });
    this.specsCols = specsCols;
  }
  /* 转化图片组 */
  srcList(data) {
    const imgList = [];
    data.forEach((item) => {
      imgList.push(item['imageUrl']);
    });
    return imgList;
  }
  /* 发送数据给抽屉 */
  openDrawer(index) {
    this.skuData = true;
    const goodsInfo = this.goodsInfo;
    const skuSign = index.toString();
    const commodityBasicInfo = {
      spuId: goodsInfo['spuId'], //spu_id
      spuName: goodsInfo['spuName'], //spu名称
      spuSkuImages: goodsInfo['spuSkuImages'],
    };
    const commoditySkuInfo = goodsInfo['commoditySkuInfo'];
    this.skuList = { commodityBasicInfo, commoditySkuInfo, skuSign };
    this.$refs['skuSidebar'].openDrawer();
  }
  /* 接收抽屉返回的数据 */
  sendCommoditySkuInfo(data) {
    console.log(data);
  }
  /* 上传规格图标更新列表数据 */
  upDateTable() {
    this.convertToSkuList();
  }
  /* 正则验证商家编码 */
  limitSkuCode(data) {
    const { value, $event } = data;
    $event.target.value = value.replace(/[^\w_-]/g, '');
  }
}
